"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransmissionStatus = void 0;
var TransmissionStatus;
(function (TransmissionStatus) {
    TransmissionStatus["TransmissionPending"] = "transmissionPending";
    TransmissionStatus["TransmissionInitiated"] = "transmissionInitiated";
    TransmissionStatus["TransmissionFailed"] = "transmissionFailed";
    TransmissionStatus["FaxWaiting"] = "faxWaiting";
    TransmissionStatus["FaxProcessing"] = "faxProcessing";
    TransmissionStatus["FaxSending"] = "faxSending";
    TransmissionStatus["FaxFailed"] = "faxFailed";
    TransmissionStatus["EmailFailed"] = "emailFailed";
    TransmissionStatus["Requested"] = "requested";
    TransmissionStatus["ToClarify"] = "toClarify";
    TransmissionStatus["Canceled"] = "canceled";
    TransmissionStatus["Faulty"] = "faulty";
    TransmissionStatus["CopyReceived"] = "copyReceived";
    TransmissionStatus["OriginalReceived"] = "originalReceived";
})(TransmissionStatus = exports.TransmissionStatus || (exports.TransmissionStatus = {}));
